import { Action } from 'redux';
import { ContractState, ContractUnloadState } from '../../states/ContractState';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractAddendum } from '../../../models/Entities/Contracts/ContractAddendum';
import { ContractBranch } from '../../../models/Entities/Contracts/ContractBranch';

export default function ContractBranchesReducer(
  state: ContractState | undefined,
  action: Action
): ContractState {
  const currentState = state ?? ContractUnloadState;
  const a: any = action;
  let CurrentContract: Contract | undefined;

  switch (a.type) {
    // Branches by contract (CRUD and bulk) - DEPRECATED: branches are now in addendums
    case 'CONTRACTBRANCH_GET_ALL_BY_CONTRACTID_RECEIVE_ACTION': {
      if (!a.contractBranches || a.contractBranches.length === 0) {
        return currentState;
      }
      
      const firstBranch = a.contractBranches[0];
      const contractId = firstBranch.contractId;
      const addendumId = firstBranch.contractAddendumId;
      
      CurrentContract = currentState.list?.find((item: Contract) => item.id === contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === addendumId);
        if (CurrentAddendum) {
          CurrentAddendum = {
            ...CurrentAddendum,
            isGettingContractBranches: false,
            isGettingContractBranchesSuccess: true,
            FailGettingContractBranches: false,
            ErrorGettingContractBranches: undefined,
            branches: a.contractBranches,
          } as ContractAddendum;
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== addendumId), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTBRANCH_UPDATE_ALL_BY_CONTRACTID_RECEIVE_ACTION': {
      if (!a.contractBranches || a.contractBranches.length === 0) {
        return currentState;
      }
      
      const firstBranch = a.contractBranches[0];
      const contractId = firstBranch.contractId;
      const addendumId = firstBranch.contractAddendumId;
      
      CurrentContract = currentState.list?.find((item: Contract) => item.id === contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === addendumId);
        if (CurrentAddendum) {
          CurrentAddendum = {
            ...CurrentAddendum,
            branches: a.contractBranches,
          } as ContractAddendum;
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== addendumId), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTBRANCH_GET_BY_ID_RECEIVE_ACTION': {
      CurrentContract = (currentState.list || []).find((item: Contract) => item.id === a.contractBranch.contractId);
      if (CurrentContract) {
        const updatedAddendums = (CurrentContract.addendums || []).map((addendum: ContractAddendum) => {
          if (addendum.id === a.contractBranch.contractAddendumId) {
            // Check if branch already exists, update it; otherwise add it
            const branchExists = addendum.branches?.some((b: ContractBranch) => b.id === a.contractBranch.id);
            const updatedBranches = branchExists
              ? (addendum.branches || []).map((branch: ContractBranch) => 
                  branch.id === a.contractBranch.id ? a.contractBranch : branch
                )
              : [...(addendum.branches || []), a.contractBranch];
            
            return {
              ...addendum,
              branches: updatedBranches
            } as ContractAddendum;
          }
          return addendum;
        });
        
        CurrentContract = {
          ...CurrentContract,
          addendums: updatedAddendums
        };
      }
      return {
        ...currentState,
        list: CurrentContract 
          ? (currentState.list || []).map((item: Contract) => item.id === CurrentContract!.id ? CurrentContract : item)
          : currentState.list,
      };
    }
    case 'CONTRACTBRANCH_CREATE_RECEIVE_ACTION': {
      CurrentContract = (currentState.list || []).find((item: Contract) => item.id === a.contractBranch.contractId);
      if (CurrentContract) {
        const updatedAddendums = (CurrentContract.addendums || []).map((addendum: ContractAddendum) => {
          if (addendum.id === a.contractBranch.contractAddendumId) {
            return {
              ...addendum,
              branches: [...(addendum.branches || []), a.contractBranch]
            } as ContractAddendum;
          }
          return addendum;
        });
        
        CurrentContract = {
          ...CurrentContract,
          addendums: updatedAddendums
        };
      }
      return {
        ...currentState,
        list: CurrentContract 
          ? (currentState.list || []).map((item: Contract) => item.id === CurrentContract!.id ? CurrentContract : item)
          : currentState.list,
      };
    }
    case 'CONTRACTBRANCH_UPDATE_REQUEST_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractBranch.contractId);
      if (CurrentContract) {
        const updatedAddendums = (CurrentContract.addendums || []).map((addendum: ContractAddendum) => {
          if (addendum.id === a.contractBranch.contractAddendumId) {
            const updatedBranches = (addendum.branches || []).map((branch: ContractBranch) => {
              if (branch.id === a.contractBranch.id) {
                return {
                  ...branch,
                  isUpdating: true,
                  isUpdatedSuccessfully: undefined,
                  failOnUpdating: false,
                } as ContractBranch;
              }
              return branch;
            });
            return {
              ...addendum,
              branches: updatedBranches
            } as ContractAddendum;
          }
          return addendum;
        });
        
        CurrentContract = {
          ...CurrentContract,
          addendums: updatedAddendums
        };
      }
      return {
        ...currentState,
        list: CurrentContract 
          ? (currentState.list || []).map((item: Contract) => item.id === CurrentContract!.id ? CurrentContract : item)
          : currentState.list,
      };
    }
    case 'CONTRACTBRANCH_UPDATE_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractBranch.contractId);
      if (CurrentContract) {
        const updatedAddendums = (CurrentContract.addendums || []).map((addendum: ContractAddendum) => {
          if (addendum.id === a.contractBranch.contractAddendumId) {
            const updatedBranches = (addendum.branches || []).map((branch: ContractBranch) => {
              if (branch.id === a.contractBranch.id) {
                return {
                  ...branch,
                  ...a.contractBranch,
                  isUpdating: false,
                  isUpdatedSuccessfully: true,
                  failOnUpdating: false,
                } as ContractBranch;
              }
              return branch;
            });
            return {
              ...addendum,
              branches: updatedBranches
            } as ContractAddendum;
          }
          return addendum;
        });
        
        CurrentContract = {
          ...CurrentContract,
          addendums: updatedAddendums
        };
      }
      return {
        ...currentState,
        list: CurrentContract 
          ? (currentState.list || []).map((item: Contract) => item.id === CurrentContract!.id ? CurrentContract : item)
          : currentState.list,
      };
    }
    case 'CONTRACTBRANCH_UPDATE_ERROR_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractBranch.contractId);
      if (CurrentContract) {
        const updatedAddendums = (CurrentContract.addendums || []).map((addendum: ContractAddendum) => {
          if (addendum.id === a.contractBranch.contractAddendumId) {
            const updatedBranches = (addendum.branches || []).map((branch: ContractBranch) => {
              if (branch.id === a.contractBranch.id) {
                return {
                  ...branch,
                  isUpdating: false,
                  isUpdatedSuccessfully: false,
                  failOnUpdating: true,
                  error: a.error,
                } as ContractBranch;
              }
              return branch;
            });
            return {
              ...addendum,
              branches: updatedBranches
            } as ContractAddendum;
          }
          return addendum;
        });
        
        CurrentContract = {
          ...CurrentContract,
          addendums: updatedAddendums
        };
      }
      return {
        ...currentState,
        list: CurrentContract 
          ? (currentState.list || []).map((item: Contract) => item.id === CurrentContract!.id ? CurrentContract : item)
          : currentState.list,
      };
    }
    case 'CONTRACTBRANCH_DELETE_RECEIVE_ACTION': {
      CurrentContract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        // Find the addendum that contains the branch to delete
        let updatedAddendums = CurrentContract.addendums?.map((addendum: ContractAddendum) => {
          const hasBranch = addendum.branches?.some((b: ContractBranch) => b.id === a.id);
          if (hasBranch) {
            return {
              ...addendum,
              branches: addendum.branches?.filter((b: ContractBranch) => b.id !== a.id) || []
            } as ContractAddendum;
          }
          return addendum;
        });
        
        if (updatedAddendums) {
          CurrentContract = {
            ...CurrentContract,
            addendums: updatedAddendums
          };
        }
      }
      return {
        ...currentState,
        list: CurrentContract 
          ? (currentState.list || []).map((item: Contract) => item.id === CurrentContract!.id ? CurrentContract : item)
          : currentState.list,
      };
    }

    // Branches by addendum (flags + set)
    case 'CONTRACTBRANCH_GET_ALL_BY_ADDENDUMID_REQUEST_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendumId);
        if (CurrentAddendum) {
          CurrentAddendum = {
            ...CurrentAddendum,
            isGettingContractBranches: true,
            isGettingContractBranchesSuccess: false,
            FailGettingContractBranches: false,
            ErrorGettingContractBranches: undefined,
          } as ContractAddendum;
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== a.addendumId), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTBRANCH_GET_ALL_BY_ADDENDUMID_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendumId);
        if (CurrentAddendum) {
          CurrentAddendum = {
            ...CurrentAddendum,
            isGettingContractBranches: false,
            isGettingContractBranchesSuccess: true,
            FailGettingContractBranches: false,
            ErrorGettingContractBranches: undefined,
            branches: a.contractBranches,
          } as ContractAddendum;
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== a.addendumId), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTBRANCH_GET_ALL_BY_ADDENDUMID_ERROR_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendumId);
        if (CurrentAddendum) {
          CurrentAddendum = {
            ...CurrentAddendum,
            isGettingContractBranches: false,
            isGettingContractBranchesSuccess: false,
            FailGettingContractBranches: true,
            ErrorGettingContractBranches: a.error,
          } as ContractAddendum;
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== a.addendumId), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }

    default:
      return currentState;
  }
}
